export default __webpack_public_path__ + "static/media/our_dream.af2e6582.png";